import { BatchContent } from "./BatchContent";
import { QuestionResponse } from "./QuestionResponse";
import { Statusable } from "../BO/BoUser";
import { QuestionCategory } from "./QuestionCategory";

export enum ResponseType {
  Text = 1,
  SingleChoice = 2,
  MultipleChoice = 3,
  Range = 4,
  Scale = 5,
  FilePicker = 6,
  List = 7,
  MultipleChoiceTags = 8,
  SingleChoiceDropdown = 9,
  DatePicker = 10,
  Location = 11,
  Autocomplete = 12,
}

export enum InputType {
  Text = "text",
  Multiline = "multiline",
  Number = "number",
  Phone = "phone",
  Datetime = "datetime",
  EmailAddress = "emailAddress",
  Url = "url",
  VisiblePassword = "visiblePassword",
  Name = "name",
  Address = "address",
  None = "none",
}

export type ResponseSetting = {
  canEdit: boolean;
  max_selections: number;
  min_selections: number;
  maxLength: number;
  validation: string;
  inputType: InputType;
  style: string;
  lines: number;
  precentageTolerance: boolean;
  inc_method: string;
  txt_max: number;
  txt_mid: string;
  txt_min: number;
  maxDate: string;
  minDate: string;
  decimal: number;
  toleranceType: boolean;
  scoreMultiplier:number;
  returnBackOnEdit: boolean;
  newVersion: boolean;
}

export type VisSetting = {
  txt_header2: number;
  extensions: string[];
  txt_button1: string;
  txt_button2: string;
  hideWhy: boolean;
  extended_content_label: string;
  extended_content_ui_mobile: string;
  placeholder: string;
  hideEye: boolean;
  image: string;
  optionsUrl: string;
  title: string;
  buttonText: string;
  searchHint: string;
  descriptionText: string;
}

export enum DealbrakerType {
  None = 0,
  Full = 1,
  Partial = 2,
}

export enum ScoringType {
  Nominal = 1,
  Ordinal = 2,
  Interval = 3,
  IntervalDate = 4,
  IntervalLocation = 5,
  Custom = 6,
  ReverseNominal = 7,
}

export enum QuestionType {
  Bio = 1,
  Pref = 2,
  Predictor = 3,
  Other = 4,
}

export enum LayoutType {
  InChat = 1,
  FullScreen = 2,
}

export class Question {
  id: number;

  
  created: Date;

  
  questionCategoryId: number;

  
  responseType: ResponseType;

  
  createdBy: number;

  
  updatedBy: number;

  
  updated: Date;

  
  layoutId: LayoutType;

  
  isReversed: boolean;

  
  isCore: boolean;

  
  brandId: number;

  
  namedId: string;

  
  defaultResponse: string;

  
  rangeMin: number;

  
  rangeMax: number;

  
  rangeInc: number;

  
  txtId: string;

  
  visSettings: VisSetting;

  
  responseSettings: ResponseSetting;

  
  skipAllowed: boolean;

  
  profileAttr: string;

  
  responseUnitId: number;

  
  userTogglable: boolean;

  
  profileAttrPolicyId: number;

  isDealBreaker: DealbrakerType;

  usedForScoring: boolean;

  scoringTypeId: ScoringType;

  
  questionType: QuestionType;

  txt: string;

  responses: QuestionResponse[];

  batchContents: BatchContent[];

  questionCategory: QuestionCategory;



}
